"use strict";

exports.__esModule = true;
exports.MOVE_DIRECTION = exports.CHECKLIST_MODE = void 0;
var MOVE_DIRECTION = Object.freeze({
  UP: 'UP',
  DOWN: 'DOWN'
});
exports.MOVE_DIRECTION = MOVE_DIRECTION;
var CHECKLIST_MODE = Object.freeze({
  EDIT: 'EDIT',
  PREVIEW: 'PREVIEW'
});
exports.CHECKLIST_MODE = CHECKLIST_MODE;